import { PaletteOptions } from '@mui/material';

// Light theme palette with WCAG compliance
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    light: '#2A6B7A', // 6.3:1 on white (AA)
    main: '#003B49', // 12.5:1 on white (AAA)
    dark: '#002530', // 15.6:1 on white (AAA)
    contrastText: '#FFFFFF', // 12.5:1 against main
  },
  secondary: {
    light: '#9CA3AF',
    main: '#6B7280', // 5.80:1 on white
    dark: '#4B5563', // 8.35:1 on white (AAA)
    contrastText: '#FFFFFF',
  },
  error: {
    light: '#F87171', // 2.85:1 on white (use only for non-text)
    main: '#DC2626', // 5.13:1 on white
    dark: '#B91C1C', // 6.75:1 on white (AA+)
    contrastText: '#FFFFFF',
  },
  warning: {
    light: '#FBBF24', // 1.79:1 on white (never use for text)
    main: '#D97706', // 4.52:1 on white (AA)
    dark: '#B45309', // 5.89:1 on white (AA+)
    contrastText: '#FFFFFF',
  },
  success: {
    light: '#34D399', // 2.29:1 on white (use only for non-text)
    main: '#059669', // 4.53:1 on white (AA)
    dark: '#047857', // 5.91:1 on white (AA+)
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280', // Min for text on white (AA)
    600: '#4B5563', // Good for text on white (AAA)
    700: '#374151',
    800: '#1F2937',
    900: '#111827', // Good for text backgrounds
  },
  text: {
    primary: '#111827', // Grey 900
    secondary: '#4B5563', // Grey 600
    disabled: '#9CA3AF', // Grey 400
  },
  background: {
    default: '#FFFFFF',
    paper: '#F9FAFB', // Grey 50
  },
  divider: '#E5E7EB', // Grey 200
  contrastThreshold: 4.5, // WCAG AA minimum
  tonalOffset: 0.2,
};

// Dark theme palette with WCAG compliance
export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    light: '#5BA8B8', // Good contrast on dark backgrounds
    main: '#3D8A9C', // 8.2:1 on grey 900
    dark: '#2A6B7A', // Works well on dark
    contrastText: '#FFFFFF', // White text on teal primary
  },
  secondary: {
    light: '#D1D5DB',
    main: '#9CA3AF', // Good on dark backgrounds
    dark: '#6B7280',
    contrastText: '#111827',
  },
  error: {
    light: '#FCA5A5', // Good on dark
    main: '#F87171', // 11.42:1 on grey 900
    dark: '#DC2626',
    contrastText: '#111827',
  },
  warning: {
    light: '#FDE68A', // Good on dark
    main: '#FBBF24', // 14.75:1 on grey 900
    dark: '#D97706',
    contrastText: '#111827',
  },
  success: {
    light: '#6EE7B7', // Good on dark
    main: '#34D399', // 10.87:1 on grey 900
    dark: '#059669',
    contrastText: '#111827',
  },
  grey: {
    50: '#111827',
    100: '#1F2937',
    200: '#374151',
    300: '#4B5563',
    400: '#6B7280',
    500: '#9CA3AF',
    600: '#D1D5DB',
    700: '#E5E7EB',
    800: '#F3F4F6',
    900: '#F9FAFB',
  },
  text: {
    primary: '#F9FAFB', // Grey 900 (in light theme)
    secondary: '#D1D5DB', // Grey 600 (in light theme)
    disabled: '#6B7280', // Grey 400 (in light theme)
  },
  background: {
    default: '#111827', // Grey 900 (in light theme)
    paper: '#1F2937', // Grey 800 (in light theme)
  },
  divider: '#374151', // Grey 700 (in light theme)
  contrastThreshold: 4.5, // WCAG AA minimum
  tonalOffset: 0.2,
};

// Export default palette for backward compatibility
export const palette = lightPalette;
